/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import { getTheme } from "@fluentui/react";

export const tableStyles = {
    headerWrapper: {
        selectors: {
            ".ms-DetailsHeader": { paddingTop: 0 } // remove extra padding on header
        }
    }
};

export const separatorStyles = {
    root: [
        {
            marginLeft: -12,
            paddingLeft: 0,
            marginTop: 16,
            paddingBottom: 16
        }
    ]
};

/** styling for the panel */
export const panelStyles = {
    root: {
        ".ms-Panel-commands": {
            backgroundColor: getTheme().semanticColors.bodyBackground
        },
        ".ms-Panel-footer": {
            backgroundColor: getTheme().semanticColors.bodyBackground,
            borderTop: "1px solid",
            borderTopColor: getTheme().semanticColors.variantBorder
        }
    }
};

export const errorStyle = { color: "#A4262C" };
